export default "__VITE_ASSET__CZgVnLYu__"